module.exports = __webpack_public_path__ + "img/SUZUKI.849864f.jpg";